import axios from "axios";

export const getDropdownAssetKategori = async () => {
    return await axios.get(`${window._HOST}admin/assetKategori/dropdown`, {withCredentials: true});
}

export const getAllDataTableAssetKategori = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/assetKategori/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/assetKategori/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const insertNewAssetKategori = async (formData) => {
    return await axios.post(`${window._HOST}admin/assetKategori`, formData, {withCredentials: true})
}

export const updateAssetKategori = async (formData, id_asset_kategori) => {
    return await axios.put(`${window._HOST}admin/assetKategori/${id_asset_kategori}`, formData, {withCredentials: true})
}

export const deleteAssetKategori = async (id_asset_kategori) => {
    return await axios.delete(`${window._HOST}admin/assetKategori/${id_asset_kategori}`, {withCredentials: true})
}